import { SELECT_LOCATION } from '../constants/actionTypes';

export default (selectedLocation = [], action) => {
  switch (action.type) {
    case SELECT_LOCATION:
      return action.payload;
    default:
      return selectedLocation;
  }
};